<app-top-menu-two *ngIf="showTopMenu"></app-top-menu-two>
<div style="height: 100vh; max-width: 800px; margin: auto;" [ngClass]="{'response': this.showTopMenu}">

    <!--Nav Top-->
    <app-nav-top title="Cashback" (back)="goBack()"></app-nav-top>

    <div class="page-content" *ngIf="user">
        <!-- Cashback Card -->

        <!-- Cashback Card & Trigger -->
        <div class="box-cashback">
            <div class="cashback-left">
                <div class="icon-bg">
                    <div class="icon-wallet"></div>
                </div>
                <div class="cashback-details">
                    <span class="cashback-label">Seu saldo atual</span>
                    <span class="cashback-value">{{ this.user.cashback | currency: 'BRL' }}</span>
                </div>
            </div>
            <div class="cashback-right" (click)="toggleRules()" *ngIf="company.configs.cashback == 1">
                <span class="rules-btn-text">Ver regras</span>
                <div class="icon-circle-question-mark" style="color: var(--primary-color); font-size: 17px;"></div>
            </div>
        </div>

        <!-- Pending Info Box -->
        <div class="pending-info-box" *ngIf="this.user.expiringSoon && this.company.configs.cashbackExpiration > 0">
            <div class="pending-icon">
                <div class="icon-triangle-alert"></div>
                
            </div>
            <p class="pending-text">
                Você tem {{ this.user.expiringSoon | currency:'BRL' }} em cashback que expira nos próximos 15 dias.
            </p>
        </div>

        <!-- Warning Info Box -->
        <div class="warning-info-box" *ngIf="abilitInfo">
             <div class="warning-icon">
                <div class="icon-info"></div>
             </div>
             <p class="warning-text">
                <strong>Cashback pendente</strong>: Cashbacks de pedidos que ainda não foram finalizados.    
             </p>
             
        </div>



        <!-- History List -->
        <div class="history-section">
            <h5 class="history-title">Histórico de transações</h5>
            
            <div class="history-list" *ngIf="historyList.length > 0">
                <ng-container *ngFor="let item of historyList">

                    <!-- 1. CASHBACK EXPIRADO -->
                    <div class="history-item expired" *ngIf="item.expired" (click)="goToOrder(item.id_order)">
                        <div class="item-left">
                            <div class="item-icon-wrapper expired">
                                <i class="icon-x"></i>
                            </div>
                            <div class="item-info">
                                <span class="item-title expired">Cashback expirado</span>
                                <span class="item-desc">{{ item.origin }} • {{ item.date }}</span>
                                <span class="item-expired">Expirado</span>
                            </div>
                        </div>
                        <div class="item-right">
                             <span class="item-value expired">
                                {{ item.value | currency: 'BRL' }}
                            </span>
                        </div>
                    </div>

                    <!-- 2. CASHBACK PENDENTE -->
                    <div class="history-item" *ngIf="!item.expired && item.status == 0" (click)="goToOrder(item.id_order)">
                        <div class="item-left">
                            <div class="item-icon-wrapper pending">
                                <i [ngClass]="item.type === 'entry' ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
                            </div>
                            <div class="item-info">
                                <span class="item-title pending">Cashback pendente</span>
                                <span class="item-desc">{{ item.origin }} • {{ item.date }}</span>
                            </div>
                        </div>
                         <div class="item-right">
                            <span class="item-value pending">
                               {{ item.type === 'entry' ? '+' : '-' }} {{ item.value | currency: 'BRL' }}
                            </span>
                        </div>
                    </div>

                    <!-- 3. CASHBACK RECEBIDO -->
                    <div class="history-item" *ngIf="!item.expired && item.status != 0 && item.type === 'entry'" (click)="goToOrder(item.id_order)">
                        <div class="item-left">
                            <div class="item-icon-wrapper entry">
                                <i class="icon-arrow-up"></i>
                            </div>
                            <div class="item-info">
                                <span class="item-title entry">Cashback recebido</span>

                                <span class="item-desc">{{ item.origin }} • {{ item.date }}</span>

                                <ng-container *ngIf="!isExpiration2099(item.expirationAt)">
                                    <span class="item-expiration" *ngIf="item.expirationRemaining && item.expirationRemaining > 0">Expira em {{ item.expirationRemaining }} dias</span>
                                    <span class="item-expiration" *ngIf="item.expirationRemaining == 0 && company.configs.cashbackExpiration != 0">Expira hoje</span>
                                </ng-container>

                            </div>
                        </div>
                        <div class="item-right">
                            <span class="item-value entry">
                                + {{ item.value | currency: 'BRL' }}
                            </span>
                        </div>
                    </div>

                    <!-- 4. CASHBACK DESCONTADO -->
                    <div class="history-item" *ngIf="!item.expired && item.status != 0 && item.type === 'exit'" (click)="goToOrder(item.id_order)">
                        <div class="item-left">
                            <div class="item-icon-wrapper exit">
                                <i class="icon-arrow-down"></i>
                            </div>
                            <div class="item-info">
                                <span class="item-title exit">Cashback descontado</span>
                                <span class="item-desc">{{ item.origin }} • {{ item.date }}</span>
                            </div>
                        </div>
                        <div class="item-right">
                            <span class="item-value exit">
                                - {{ item.value | currency: 'BRL' }}
                            </span>
                        </div>
                    </div>

                </ng-container>
            </div>

            <div class="history-empty" *ngIf="historyList.length === 0">
                <span>Nenhum histórico de transações encontrado.</span>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="showRules">
    <app-rules-cashback (closeCanvas)="toggleRules()" [company]="company"></app-rules-cashback>
</ng-container>